import React from 'react'
import SingleLineJob from './SingleLineJob'

const Skills = ({skills}) => {
  return (
    <div className="container px-2 py-3 py-md-5 d-flex flex-column align-items-center">
        <div className="headerText text-center">Skills you will gain</div>
        <div className="row align-items-center justify-content-center mt-3" style={{gap: 'clamp(1rem, 2.5vw, 2rem)'}}>
        {skills.map((item) => (
            <SingleLineJob item={item} />
        ))}
      </div>
    </div>
  )
}

export default Skills